import { useBrandConfig } from '~/config/branding';
import { Benefits } from './Benefits';
import { FAQ } from './FAQ';

export const Providers = () => {
  const { siteName } = useBrandConfig();
  return (
    <div className="text-left min-h-screen bg-white">
      {/* [MCV-1512] See Organizations.tsx — page-level title for the heading
          outline, `sr-only` because the visual design has none.
          [MCV-1490] Brand-specific now that each site shows only its own
          section; the StartGuide ("Guide, getting started") was removed per the
          ticket. */}
      <h1 className="sr-only">{siteName} for healthcare providers</h1>
      <Benefits />
      <FAQ />
    </div>
  );
};

export default Providers;
